import { render, staticRenderFns } from "./LoginInterface.vue?vue&type=template&id=467cda95&scoped=true&"
import script from "./LoginInterface.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LoginInterface.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cda95",
  null
  
)

export default component.exports